import React from "react";
import { motion } from "framer-motion";
import { Col, Row } from "antd";
import src from "../style/images/galleryImg1.jpg";
import src2 from "../style/images/IMP07041.JPG";
import src1 from "../style/images/col_02.jpeg";
import src3 from "../style/images/col_04.jpeg";


const WhatWeDo = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };
  return (
    <section className="whatwedo-section">
      <div className="overlay"></div>
      <div className="whatwedo-container">
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <motion.h2
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="whatwedo-title"
            >
              What We Do
            </motion.h2>
          </Col>

          <Col xs={24} md={12}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="whatwedo-content"
            >
              <p>
                • <b>Corporate & Lifestyle Events: </b> Launches, summits,
                celebrations, and experiences that align perfectly with brand
                ethos.
              </p>
              <p>
                • <b>Luxury Brand Collaborations: </b> Strategic partnerships
                and showcases for premium brands like Jaguar, BMW, Mercedes,
                Harley Davidson, GRT Jewellers, Palladium Mall, DBS Bank and
                more.
              </p>
              <p>
                • <b>Experiential Marketing: </b> From concept to execution, we
                curate engagements that spark conversations and strengthen brand
                recall.
              </p>
              <p>
                • <b>Sponsorship Management & Brand Integrations: </b> Smart,
                data-driven brand alliances that deliver visibility and value.
              </p>
              <p>
                • <b>Creative & Digital Strategy: </b> Integrated campaigns that
                connect on-ground experiences with digital storytelling for
                lasting audience engagement.
              </p>
            </motion.div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <motion.div
              // key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src1} alt={`Gallery`} loading="lazy" />
            </motion.div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <motion.div
              // key={index}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src2} alt={`Gallery`} loading="lazy" />
            </motion.div>
          </Col>
          <Col xs={24} md={12}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="sub-section"
            >
              <h3>Our Philosophy</h3>
              <p>
                • Every event is an opportunity to catapult ideas into impact.
                We believe in the power of design thinking, emotional
                connection, and strategic precision — because experiences that
                move people are the ones that move brands forward.
              </p>
              <p>
                • Our success lies in seamless execution, innovative concepts,
                and deep client collaboration. Whether it’s a luxury showcase, a
                sports tournament, or a high-profile corporate meet, we ensure
                each detail reflects the brand’s essence and our uncompromising
                pursuit of excellence.
              </p>
              <p className="quote">
                “We don’t follow trends — we set the stage for them.”
              </p>
            </motion.div>
          </Col>
          <Col xs={24} md={12}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="sub-section"
            >
              <h3>Our Edge</h3>
              <ul>
                <li>
                  • End-to-end project ownership with in-house creative and
                  production teams.
                </li>
                <li>
                  • Strong partnerships with premium venues, lifestyle brands,
                  and media houses.
                </li>
                <li>
                  • A results-oriented approach combining strategy,
                  storytelling, and execution.
                </li>
                <li>
                  • Over a decade of experience driving brand experiences that
                  convert visibility into value.
                </li>
              </ul>
            </motion.div>
          </Col>

          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <motion.div
              // key={index}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src3} alt={`Gallery`} loading="lazy" />
            </motion.div>
          </Col>

          <Col xs={24}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="closing-statement"
            >
              <p>
                At <span>Catapult Media Works</span>, we don’t just organize
                events — we engineer emotions, amplify brands, and create
                moments that live beyond the spotlight.
              </p>
              <p>Because every great brand deserves an unforgettable stage.</p>
            </motion.div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default WhatWeDo;
